/** Label and tag colour for a trip on its way back; the list only holds these four, any other word is shown as it is. */
const RETURN_STATUS_TAGS: Record<string, { label: string; color: string }> = {
  dispatched: { label: 'Dispatched', color: 'processing' },
  in_transit: { label: 'On the road', color: 'processing' },
  exception: { label: 'Exception', color: 'error' },
  delivered: { label: 'Delivered', color: 'success' },
};

export function returnStatusTag(status: string): { label: string; color: string } {
  return RETURN_STATUS_TAGS[status] ?? { label: status.replaceAll('_', ' '), color: 'default' };
}
